(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-section"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('contact-form-multiselect')) {
    class ContactFormMultiselect extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-toggle]');
        this.panel = this.querySelector('[data-panel]');
        this.summary = this.querySelector('[data-summary]');
        this.value = this.querySelector('[data-value]');
        this.error = this.querySelector('[data-error]');
        this.options = Array.from(this.querySelectorAll('[data-option]'));

        if (!this.toggle || !this.panel) {
          return;
        }

        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.toggle.addEventListener('click', () => this.setOpen(this.panel.hidden), { signal });

        this.options.forEach((option) => {
          option.addEventListener('change', () => this.sync(), { signal });
        });

        document.addEventListener(
          'click',
          (event) => {
            if (!this.contains(event.target)) {
              this.setOpen(false);
            }
          },
          { signal }
        );

        this.addEventListener(
          'keydown',
          (event) => {
            if (event.key === 'Escape' && !this.panel.hidden) {
              event.stopPropagation();
              this.setOpen(false);
              this.toggle.focus();
            }
          },
          { signal }
        );

        this.form = this.closest('form');

        if (this.form && this.hasAttribute('data-required')) {
          this.form.addEventListener(
            'submit',
            (event) => {
              if (!this.value.value) {
                event.preventDefault();
                this.showError();
                this.setOpen(true);
                this.toggle.focus();
              }
            },
            { signal }
          );
        }

        this.sync();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      setOpen(open) {
        this.panel.hidden = !open;
        this.toggle.setAttribute('aria-expanded', String(open));
      }

      showError() {
        if (!this.error) return;
        this.error.textContent = this.getAttribute('data-error-message') || 'Please select at least one option.';
        this.error.hidden = false;
        this.toggle.setAttribute('aria-invalid', 'true');
      }

      sync() {
        const selected = this.options.filter((option) => option.checked).map((option) => option.value);

        this.value.value = selected.join(', ');

        const placeholder = this.getAttribute('data-placeholder') || '';

        if (selected.length === 0) {
          this.summary.textContent = placeholder;
          this.toggle.setAttribute('data-empty', '');
        } else if (selected.length === 1) {
          this.summary.textContent = selected[0];
          this.toggle.removeAttribute('data-empty');
        } else {
          this.summary.textContent = `${selected.length} selected`;
          this.toggle.removeAttribute('data-empty');
        }

        if (selected.length > 0 && this.error) {
          this.error.hidden = true;
          this.toggle.removeAttribute('aria-invalid');
        }
      }
    }

    window.customElements.define('contact-form-multiselect', ContactFormMultiselect);
  }

  if (!window.customElements.get('contact-form-file-input')) {
    class ContactFormFileInput extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-input]');
        this.previews = this.querySelector('[data-previews]');
        this.error = this.querySelector('[data-error]');
        this.hint = this.querySelector('[data-hint]');

        if (!this.input) {
          return;
        }

        this.maxFiles = parseInt(this.getAttribute('data-max-files'), 10) || 3;
        this.maxSize = (parseFloat(this.getAttribute('data-max-size')) || 5) * 1024 * 1024;
        this.objectUrls = [];

        if (this.hint) {
          this.hint.textContent = `Up to ${this.maxFiles} images, max ${this.getAttribute('data-max-size')}MB each`;
        }

        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.input.addEventListener('change', () => this.validate(), { signal });

        ['dragenter', 'dragover'].forEach((name) => {
          this.addEventListener(
            name,
            (event) => {
              event.preventDefault();
              this.setAttribute('data-dragging', '');
            },
            { signal }
          );
        });

        ['dragleave', 'drop'].forEach((name) => {
          this.addEventListener(
            name,
            (event) => {
              event.preventDefault();
              if (name === 'dragleave' && this.contains(event.relatedTarget)) return;
              this.removeAttribute('data-dragging');
            },
            { signal }
          );
        });

        this.addEventListener(
          'drop',
          (event) => {
            if (!event.dataTransfer?.files.length) return;
            this.input.files = event.dataTransfer.files;
            this.validate();
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.releaseUrls();
      }

      releaseUrls() {
        this.objectUrls.forEach((url) => URL.revokeObjectURL(url));
        this.objectUrls = [];
      }

      showError(message) {
        if (!this.error) return;
        this.error.textContent = message;
        this.error.hidden = !message;
      }

      validate() {
        const files = Array.from(this.input.files);

        if (files.length > this.maxFiles) {
          this.showError(`Please select no more than ${this.maxFiles} images.`);
          this.input.value = '';
          this.render([]);
          return;
        }

        const oversized = files.find((file) => file.size > this.maxSize);

        if (oversized) {
          this.showError(`"${oversized.name}" is larger than ${this.getAttribute('data-max-size')}MB.`);
          this.input.value = '';
          this.render([]);
          return;
        }

        this.showError('');
        this.render(files);
      }

      remove(index) {
        const transfer = new DataTransfer();

        Array.from(this.input.files).forEach((file, i) => {
          if (i !== index) transfer.items.add(file);
        });

        this.input.files = transfer.files;
        this.validate();
      }

      render(files) {
        if (!this.previews) return;

        this.releaseUrls();
        this.previews.textContent = '';
        this.previews.hidden = files.length === 0;

        files.forEach((file, index) => {
          const url = URL.createObjectURL(file);
          this.objectUrls.push(url);

          const item = document.createElement('li');
          item.className = 'contact-form__preview';

          const image = document.createElement('img');
          image.src = url;
          image.alt = file.name;
          image.loading = 'lazy';

          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'contact-form__preview-remove';
          remove.textContent = '\u00d7';
          remove.setAttribute('aria-label', `Remove ${file.name}`);
          remove.addEventListener('click', () => this.remove(index));

          item.append(image, remove);
          this.previews.append(item);
        });
      }
    }

    window.customElements.define('contact-form-file-input', ContactFormFileInput);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero-video"] && !Shopify.designMode) return;
  try {
    
  /**
   * Hero video player.
   *
   *  - Defers the YouTube/Vimeo iframe until the section approaches the viewport.
   *  - Tracks real playback state reported by the provider, never assumed from `load`.
   *    The embed stays hidden behind the poster unless it is genuinely playing, which is
   *    what keeps YouTube's stopped-state overlay (centre play button, title, channel
   *    credit) off the page. `controls=0` alone does not remove it.
   *  - Buffering after playback has started does not uncover the poster: YouTube's
   *    loop restart passes through ended -> buffering -> playing, and revealing the
   *    frame there would flash the end-screen. A short grace timer covers a genuine
   *    stop so the poster still returns if the loop ever fails.
   *  - Pauses playback while off screen, resumes on return unless the visitor paused it.
   *  - Honours prefers-reduced-motion and the merchant's autoplay setting.
   *
   * Hosted videos are rendered by Prestige's `media` snippet, so the theme keeps ownership of
   * preloading and poster swapping; this element only reads the <video> the snippet produced.
   */
  class HeroVideoPlayer extends HTMLElement {
    connectedCallback() {
      this.provider = this.dataset.provider;
      this.iframe = this.querySelector('.hero-video__iframe');
      this.toggleButton = this.querySelector('[data-action="toggle-playback"]');
      this.label = this.querySelector('[data-playback-label]');

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.pausedByVisitor = prefersReducedMotion || this.dataset.autoplay === 'false';

      this.abortController = new AbortController();

      this.toggleButton?.addEventListener('click', this.onToggleClicked.bind(this), {
        signal: this.abortController.signal
      });

      if (this.provider === 'hosted') {
        this.setupHostedVideo();
      } else if (this.iframe) {
        this.setupEmbed();
      }

      this.observeVisibility();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.visibilityObserver?.disconnect();
      this.loadObserver?.disconnect();
      clearInterval(this.handshakeTimer);
      clearTimeout(this.loopGraceTimer);
    }

    /* The visible <video> — a second one may exist for the other breakpoint */
    get video() {
      return Array.from(this.querySelectorAll('video'))
        .filter((video) => video.offsetParent !== null)
        .pop();
    }

    setupHostedVideo() {
      const { signal } = this.abortController;

      this.addEventListener('playing', () => this.setState(true), { capture: true, signal });
      this.addEventListener('pause', () => this.setState(false), { capture: true, signal });
      this.addEventListener('ended', () => this.setState(false), { capture: true, signal });

      if (this.pausedByVisitor) {
        this.querySelectorAll('video').forEach((video) => {
          video.removeAttribute('autoplay');
          video.pause();
        });
      }
    }

    /* Only fetch the provider bundle once the hero is close to the viewport */
    setupEmbed() {
      const { signal } = this.abortController;

      window.addEventListener('message', this.onProviderMessage.bind(this), { signal });

      const load = () => {
        let src = this.iframe.dataset.src;
        if (this.pausedByVisitor) src = src.replace('autoplay=1', 'autoplay=0');
        if (this.provider === 'youtube') src += `&origin=${encodeURIComponent(window.location.origin)}`;

        this.iframe.addEventListener('load', () => this.startHandshake(), { once: true, signal });
        this.iframe.src = src;
      };

      if (!('IntersectionObserver' in window)) return load();

      this.loadObserver = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          this.loadObserver.disconnect();
          load();
        },
        { rootMargin: '400px' }
      );

      this.loadObserver.observe(this);
    }

    /**
     * Both providers only emit state events after they have been subscribed to. The first
     * request can land before the player inside the iframe is ready, so it is repeated
     * until a message comes back or a short window elapses.
     */
    startHandshake() {
      let attempts = 0;

      const subscribe = () => {
        if (this.provider === 'youtube') {
          this.postCommand({ event: 'listening', id: 1, channel: 'widget' });
        } else {
          this.postCommand({ method: 'addEventListener', value: 'play' });
          this.postCommand({ method: 'addEventListener', value: 'pause' });
        }

        if (++attempts >= 12 || this.hasProviderContact) clearInterval(this.handshakeTimer);
      };

      subscribe();
      this.handshakeTimer = setInterval(subscribe, 250);
    }

    onProviderMessage(event) {
      if (!this.iframe || event.source !== this.iframe.contentWindow) return;

      let data = event.data;

      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch {
          return;
        }
      }

      if (!data || typeof data !== 'object') return;

      this.hasProviderContact = true;

      if (this.provider === 'youtube') {
        const state = data.info?.playerState ?? (data.event === 'onStateChange' ? data.info : undefined);
        if (typeof state !== 'number') return;
        this.onYouTubeState(state);
      } else if (data.event === 'play') {
        this.setState(true);
      } else if (data.event === 'pause' || data.event === 'ended') {
        this.setState(false);
      }
    }

    /* 1 playing, 3 buffering, 0 ended, 2 paused, -1 unstarted, 5 cued */
    onYouTubeState(state) {
      clearTimeout(this.loopGraceTimer);

      if (state === 1) {
        this.hasPlayed = true;
        return this.setState(true);
      }

      if (state === 2 || this.pausedByVisitor) {
        return this.setState(false);
      }

      // Ended or buffering mid-loop: hold the frame rather than flashing the end screen,
      // but give up after a moment if playback genuinely does not resume.
      if (this.hasPlayed && (state === 0 || state === 3)) {
        this.loopGraceTimer = setTimeout(() => this.setState(false), 1500);
        return;
      }

      this.setState(false);
    }

    postCommand(payload) {
      this.iframe?.contentWindow?.postMessage(JSON.stringify(payload), '*');
    }

    play() {
      switch (this.provider) {
        case 'hosted':
          this.video?.play().catch(() => this.setState(false));
          break;
        case 'youtube':
          this.postCommand({ event: 'command', func: 'playVideo', args: [] });
          break;
        case 'vimeo':
          this.postCommand({ method: 'play' });
          break;
      }
    }

    pause() {
      switch (this.provider) {
        case 'hosted':
          this.video?.pause();
          break;
        case 'youtube':
          this.postCommand({ event: 'command', func: 'pauseVideo', args: [] });
          break;
        case 'vimeo':
          this.postCommand({ method: 'pause' });
          break;
      }

      // Cover the frame immediately rather than waiting for the provider to confirm,
      // so a paused embed never flashes its stopped-state overlay.
      if (this.provider !== 'hosted') {
        clearTimeout(this.loopGraceTimer);
        this.setState(false);
      }
    }

    onToggleClicked() {
      this.pausedByVisitor = this.dataset.playing === 'true';
      this.pausedByVisitor ? this.pause() : this.play();
    }

    setState(isPlaying) {
      this.dataset.playing = isPlaying ? 'true' : 'false';
      if (this.label) this.label.textContent = isPlaying ? 'Pause video' : 'Play video';
    }

    /* Never keep decoding frames the visitor cannot see */
    observeVisibility() {
      if (!('IntersectionObserver' in window)) return;

      this.visibilityObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            if (!this.pausedByVisitor) this.play();
          } else if (this.dataset.playing === 'true') {
            this.pause();
          }
        },
        { threshold: 0.15 }
      );

      this.visibilityObserver.observe(this);
    }
  }

  if (!window.customElements.get('hero-video-player')) {
    window.customElements.define('hero-video-player', HeroVideoPlayer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-grid"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('team-grid-carousel')) {
    class TeamGridCarousel extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-scroller]');
        this.progress = this.querySelector('[data-progress]');

        if (!this.scroller || !this.progress) {
          return;
        }

        this.abortController = new AbortController();
        this.ticking = false;

        this.scroller.addEventListener('scroll', () => this.requestUpdate(), {
          passive: true,
          signal: this.abortController.signal,
        });

        this.resizeObserver = new ResizeObserver(() => this.requestUpdate());
        this.resizeObserver.observe(this.scroller);

        this.update();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
      }

      requestUpdate() {
        if (this.ticking) {
          return;
        }

        this.ticking = true;

        requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.scroller;
        const overflowing = scrollWidth - clientWidth > 1;

        this.toggleAttribute('data-overflowing', overflowing);

        if (!overflowing) {
          this.progress.style.setProperty('--progress', '1');
          return;
        }

        const ratio = (Math.abs(scrollLeft) + clientWidth) / scrollWidth;

        this.progress.style.setProperty('--progress', Math.min(1, Math.max(0, ratio)).toFixed(4));
      }
    }

    window.customElements.define('team-grid-carousel', TeamGridCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-banner"] && !Shopify.designMode) return;
  try {
    
if (!window.customElements.get('text-banner')) {
  class TextBanner extends HTMLElement {
    connectedCallback() {
      const target = this.querySelector('[data-reveal]');

      if (!target) {
        return;
      }

      if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches || !('IntersectionObserver' in window)) {
        target.removeAttribute('data-reveal');
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add('text-banner__content--revealed');
            entry.target.removeAttribute('data-reveal');
            this.observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -10% 0px' }
      );

      this.observer.observe(target);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  window.customElements.define('text-banner', TextBanner);
}

  } catch(e) { console.error(e); }
})();
})();
